import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "container p-0",
    style: { "flex": "1 1 0" }
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "row mb-3 small" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-md-12" }, " Für die Registierung am Web-Portal geben Sie bitte Ihre Daten ein. Sobald wir Ihre Angeben geprüft haben, erhalten Sie einen Zugang. ")
], -1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-12" };
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col-md-6" };
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "row mb-2" }, [
    /*#__PURE__*/ _createElementVNode("div", {
        class: "col-md-12 text-muted",
        style: { "font-size": ".7em" }
    }, " Das Kennwort muss mindestens 8 Zeichen lang sein, einen Kleinbuchstaben, einen Großbuchstaben, eine Ziffer und ein Sonderzeichen enthalten. Es muss mindestens ein eindeutiges Zeichen enthalten sein. ")
], -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-md-12" }, [
        /*#__PURE__*/ _createElementVNode("hr", { class: "m-0 mb-1" })
    ])
], -1);
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col-md-6" };
const _hoisted_12 = { class: "col-md-6" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "col-md-12" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-md-12" }, [
        /*#__PURE__*/ _createElementVNode("hr", { class: "m-0 mb-1" })
    ])
], -1);
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "col-md-12" };
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-md-12" };
const _hoisted_20 = { class: "row" };
const _hoisted_21 = { class: "col-md-12" };
const _hoisted_22 = { class: "row" };
const _hoisted_23 = { class: "col-md-12" };
const _hoisted_24 = { class: "row" };
const _hoisted_25 = { class: "col-md-5" };
const _hoisted_26 = { class: "col-md-7" };
const _hoisted_27 = { class: "row" };
const _hoisted_28 = { class: "col-md-12" };
const _hoisted_29 = {
    key: 0,
    class: "row"
};
const _hoisted_30 = { class: "col-md-12" };
const _hoisted_31 = { class: "mb-3 error__message-container" };
const _hoisted_32 = { class: "row align-middle" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("div", { class: "col-sm-7 my-auto text-left align-middle pr-0" }, null, -1);
const _hoisted_34 = { class: "col-sm-5 text-right pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        "show-logo": false,
        title: "Registrieren",
        "back-link-path": "/login"
    }, {
        default: _withCtx(() => [
            _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.eMail",
                                label: "eMail-Adresse*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.password",
                                label: _ctx.$tc('account.Password.Registration.Password') + '*',
                                dataObject: _ctx.$data,
                                mode: "password"
                            }, null, 8, ["label", "dataObject"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.confirmPassword",
                                label: _ctx.$tc('account.Password.Registration.Confirm') + '*',
                                dataObject: _ctx.$data,
                                mode: "password"
                            }, null, 8, ["label", "dataObject"])
                        ])
                    ]),
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.firstName",
                                label: "Vorname*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.lastName",
                                label: "Nachname*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.telephone",
                                label: "Telefonnummer*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_name1",
                                label: "Name 1*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_name2",
                                label: "Name 2",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_addition",
                                label: "Zusatz",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_street",
                                label: "Straße*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_zipcode",
                                label: "Postleitzahl*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_city",
                                label: "Ort*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.euvatid",
                                label: "Umsatsteuer-ID*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    (_ctx.hasErrors(_ctx.$form.results))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterErrors(_ctx.$form.results), (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", null, _toDisplayString(item.message), 1));
                                    }), 256))
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_g_button, {
                            text: "Registrieren",
                            disabled: _ctx.disableSubmit,
                            onClick: _ctx.OnExecute
                        }, null, 8, ["disabled", "onClick"])
                    ])
                ])
            ])
        ]),
        _: 1
    }));
}
